var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { staticStyle: { margin: "10px 0 10px 0" } },
        [
          _c("el-col", { attrs: { span: 12 } }, [
            _c("h1", [_vm._v("Gestion mensuelle")])
          ]),
          _vm._v(" "),
          _c(
            "el-col",
            { staticStyle: { "text-align": "right" }, attrs: { span: 12 } },
            [
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    size: "mini",
                    icon: "el-icon-check"
                  },
                  on: { click: _vm.handleSave }
                },
                [_vm._v("Enregistrer")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form",
        {
          ref: "ElForm",
          staticStyle: { width: "600px" },
          attrs: { model: _vm.formData, "label-width": "250px", size: "mini" }
        },
        [
          _c("h2", [
            _vm._v(
              "Traitement automatique de la validation de la synthèse de gestion"
            )
          ]),
          _vm._v(" "),
          _c("el-form-item", { attrs: { label: "Société" } }, [
            _vm._v(_vm._s(_vm.$store.getters.user.societe_name))
          ]),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              staticStyle: { width: "500px" },
              attrs: { label: "Jour du traitement automatique", prop: "day" }
            },
            [
              _c("el-input-number", {
                attrs: { min: 1, max: 28 },
                model: {
                  value: _vm.formData.day,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "day", $$v)
                  },
                  expression: "formData.day"
                }
              }),
              _vm._v(" "),
              _c("span", [_vm._v("de chaque mois")])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              attrs: { label: "Traitement automatique activé", prop: "actif" }
            },
            [
              _c("el-switch", {
                attrs: {
                  "active-value": Number(1),
                  "inactive-value": Number(0),
                  "active-color": "#13ce66",
                  "inactive-color": "#ff4949",
                  "active-text": "Oui",
                  "inactive-text": "Non"
                },
                model: {
                  value: _vm.formData.actif,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "actif", $$v)
                  },
                  expression: "formData.actif"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _c(
            "div",
            { key: _vm.refresh },
            [
              _vm.isProcessing
                ? _c("el-alert", {
                    staticStyle: {
                      "margin-bottom": "5px",
                      "font-weight": "bold"
                    },
                    attrs: {
                      title:
                        "Traitement démarré le " +
                        _vm.processingStartTime +
                        " (Durée: " +
                        _vm.processingElapsedTime +
                        ")",
                      type: "warning",
                      "show-icon": "",
                      center: "",
                      closable: false
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "Date dernière exécution",
                    prop: "last_executed"
                  }
                },
                [
                  _vm.isProcessing
                    ? _c("span", [_vm._v("Traitement en cours")])
                    : _c("span", [_vm._v(_vm._s(_vm.lastExecuted))])
                ]
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "Période mensuelle créée",
                    prop: "last_periode"
                  }
                },
                [
                  _vm.isProcessing
                    ? _c("span", [_vm._v("Traitement en cours")])
                    : _c("span", [_vm._v(_vm._s(_vm.lastPeriode))])
                ]
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "Résultat exécution", prop: "last_status" } },
                [
                  _vm.isProcessing
                    ? _c("span", [_vm._v("Traitement en cours")])
                    : _vm.formData.last_status === "1"
                    ? _c(
                        "span",
                        [
                          _c("el-alert", {
                            staticStyle: { width: "150px", height: "30px" },
                            attrs: {
                              "show-icon": "",
                              closable: false,
                              title: "Avec succès",
                              type: "success"
                            }
                          })
                        ],
                        1
                      )
                    : _vm.formData.last_status === "0"
                    ? _c(
                        "span",
                        [
                          _c("el-alert", {
                            staticStyle: { width: "150px", height: "30px" },
                            attrs: {
                              "show-icon": "",
                              size: "mini",
                              closable: false,
                              title: "En erreur",
                              type: "error"
                            }
                          })
                        ],
                        1
                      )
                    : _c("span", [_vm._v("--")])
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "Exécution manuelle" } },
            [
              _c(
                "el-button",
                {
                  attrs: {
                    disabled:
                      _vm.formData.last_periode === "202109" ||
                      _vm.isProcessing,
                    icon: "el-icon-setting",
                    type: "success",
                    size: "mini"
                  },
                  on: { click: _vm.handleExecute }
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.isProcessing
                          ? "Traitement en cours..."
                          : "Démarrer maintenant"
                      ) +
                      "\n      "
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              staticStyle: { width: "500px" },
              attrs: {
                label: "Période mensuelle de référence",
                prop: "periodeRef"
              }
            },
            [
              _c("el-input", {
                staticStyle: { width: "60px" },
                attrs: { maxlength: "6" },
                model: {
                  value: _vm.periodeRef_gestmens,
                  callback: function($$v) {
                    _vm.periodeRef_gestmens = $$v
                  },
                  expression: "periodeRef_gestmens"
                }
              }),
              _vm._v(" (format: YYYYMM)\n    ")
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }